import { Box, Button, Checkbox, FormGroup, Grid, Paper, Skeleton, TextField, Tooltip, Typography } from "@mui/material";
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from "../../../elements";
import { Edit as EditIcon } from "@mui/icons-material";
import AssemblyTable from "../../../elements/AssemblyTable";
import { useEffect, useState } from "react";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { checkApiStatus, getTextFieldRows } from "../../../../utils";
import { useParams } from "react-router";
import EditRedelivery from "../components/EditRedelivery";
import { addAssemblysActulConfigApi, deleteAssemblysApi, deleteAssemblysEventApi, getAssemblysList, getReDeliveryConditionApi } from "../apiService";
import CustomTab from "../../../elements/CustomTab";
import AddAssemblys from "../components/AddAssemblys";
import { DeletePopUp, PageLoader } from "../../../../shared_elements";
import EditAssemblysEvent from "../../redelivery/components/EditAssemblysEvent";
import { enqueueSnackbar } from "notistack";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import { trackActivity } from "../../../../utils/mixpanel";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import moment from "moment";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import { ShowAttachments } from '../../../../shared_elements/components';
import { useSelector } from "react-redux";
import FileUploadLayout from "../../../../shared_elements/components/FileUploadLayout";
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const Redelivery = () => {
    const params = useParams();
    const {  fileUploadDetails } = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [editRedelivery, setEditRedelivery] = useState({ modal: false, data: null })
    const [addAssemblys, setAddAssemblys] = useState({ mode: '', modal: false, data: null });
    const [addAssemblysActualConfigType, setAddAssemblysActualConfigType] = useState([]);
    const [deleteEvents, setDeleteEvents] = useState({ modal: false, data: null, })
    const [deleteAssemblys, setDeleteAssemblys] = useState({ modal: false, data: null, })
    const [editEvent, setEditEvent] = useState({ mode: '', modal: false, data: null });
    const [assemblysType, setAssemblysType] = useState([])
    const [tabValue, setTabValue] = useState(0);
    const [isDropDownLoading, setIsDropDownLoading] = useState({ data: false, assemblyType: false, actualConfigDetails: false });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const contentScrollSx = { maxHeight: "calc(100vh - 320px)", overflowY: "auto", pr: 1 };
    const [editmode, setEdit] = useState(false);
    const [uploadfile, setUploadfile] = useState({ mode: '', modal: false, data: null });
    const [uploadFileProgressData, setUploadFileProgressData] = useState({});
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug] = useState({});

    useEffect(() => {
        const uploadedFileData = getApiResponse("return_condition", slug);
        setUploadFileProgressData({ uploadedFileData });
        getDeliveryConditionDetail('skeletonLoader', {});
        getAssemblysTypeList('skeletonLoader', {})
        trackActivity('Page Viewed', { page_title: 'Return Condition' })
    }, []);

    const getDeliveryConditionDetail = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, data: true })) : setLoading(true);
        globalGetService(getReDeliveryConditionApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, data: false })) : setLoading(false);
                setData(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, data: false })) : setLoading(false);
            }
        })
    };

    const getAssemblysTypeList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, assemblyType: true })) : setLoading(true);
        globalGetService(getAssemblysList(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, assemblyType: false })) : setLoading(false);
                setAssemblysType(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, assemblyType: false })) : setLoading(false);
            }
        })
    };
    const getAssemblysTypeActualConfigList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, actualConfigDetails: true })) : setLoading(true);
        globalGetService(addAssemblysActulConfigApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, actualConfigDetails: false })) : setLoading(false);
                setAddAssemblysActualConfigType(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, actualConfigDetails: false })) : setLoading(false);
            }
        })
    };

    const onDeleteAssembly = () => {
        setLoading(true);
        globalDeleteService(deleteAssemblysApi({ params, assembly_slug: deleteAssemblys?.data?.assembly_slug, }), { ids: [deleteAssemblys?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Return Condition Assembly`, success_msg: response?.data?.message, item_ids: deleteAssemblys?.data, response: response?.data })
                    setDeleteAssemblys({ modal: false, data: null });
                    getAssemblysTypeList('fetch');
                    //   setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Return Condition Assembly`, error_msg: response?.data?.message, item_ids: deleteAssemblys?.data, response: response?.data })
                }
            })
    }


    const onDeleteAssemblyEvent = () => {
        setLoading(true);
        globalDeleteService(deleteAssemblysEventApi({ params, asset: deleteEvents?.data?.asset, assembly_slug: deleteEvents?.data?.assembly_slug, event_slug: deleteEvents?.data?.event_slug }), { ids: [deleteEvents?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Return Condition Assembly Event`, success_msg: response?.data?.message, item_ids: deleteEvents?.data, response: response?.data })
                    setDeleteEvents({ modal: false, data: null });
                    getAssemblysTypeList('fetch');
                    //   setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Return Condition Assembly Event`, error_msg: response?.data?.message, item_ids: deleteEvents?.data, response: response?.data })
                }
            })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "delivery_redelivery_maintenance_event",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => { setUploadFileProgressData({ progressRefs, attachments, response }); },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getAssemblysTypeList('fetch');
            },
            onError: (err) => {
                enqueueSnackbar(err?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    };

    const onDeletAttachments = (deletedSlug) => {
        setUploadfile(prev => ({
            ...prev,
            data: { ...prev.data, attachments: prev.data.attachments.filter(item => item.slug !== deletedSlug) }
        }));
        getAssemblysTypeList('fetch');
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Return Condition`, page_type: page_type, })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-details-height lease-module-paper'>
                <LeasesNav type="terms"/>
                <div className='lease-details-content lease-detail-content-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='end'>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <LeasesMenuList btnText='Return Condition' type="terms"/>
                            </Grid>
                            <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid size={{ md: 4, xs: 12 }} >
                                <Box sx={{ display: "flex", justifyContent: "flex-end",padding:'0px',minHeight:'35px' }}>
                                    <ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} />
                                    {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "return_conditions", operationType: ['U'] }}>
                                        <Tooltip title="Edit"><EditIcon fontSize="small" color="primary" className='delivery-edit-btn' onClick={() => { setEditRedelivery({ modal: true, data: data, mode: 'add' }); handleItemClicked('EditIcon') }} /></Tooltip>
                                    </PermissionWrapper> */}
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Box className='tab-detail-container'>
                        <Grid className="redelivery-contractual-container" container spacing={2} sx={{ height: "calc(100vh - 245px)", maxHeight: "calc(100vh - 245px)", overflow: "hidden" }}>
                            <Box sx={{ height: '100%', width: '100%' }}>
                                <CustomTab
                                    getAssemblysTypeList={getAssemblysTypeList}
                                    getAssemblysTypeActualConfigList={getAssemblysTypeActualConfigList}
                                    setValue={setTabValue}
                                    value={tabValue}
                                    tabs={[
                                    {
                                        label: 'Contractual Config',
                                        content: <Box className="contractual-config-table" sx={contentScrollSx}>
                                            <Box display="flex" justifyContent="space-between" marginBottom={1}>
                                                <Typography color='primary' className='delivery-header' >Return Assemblies</Typography>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "return_conditions", operationType: ['C'] }}>
                                                    <Button variant="contained" color="primary" size='small' startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' onClick={() => { setAddAssemblys({ modal: true, data: { assemblies: null, base_TSN: data?.base_TSN, base_CSN: data?.base_CSN }, mode: 'add' }); handleItemClicked('Add Assembly Button') }} >Add Assembly</Button>
                                                </PermissionWrapper>
                                            </Box>
                                            {
                                                isDropDownLoading.assemblyType ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} variant="rectangular" height={40} />) :
                                                    assemblysType.length > 0 ? assemblysType?.map((data, index) => {
                                                        return (
                                                            <AssemblyTable
                                                                viewRevisonHistory={(item, event, slug) => setRevisionHistory({ modal: true, data: event === "event" ? item : data, mode: "view", tableName: event })}
                                                                key={index}
                                                                tsn={data?.tsn}
                                                                csn={data?.csn}
                                                                blockHours={data?.block_hours}
                                                                asset={data?.asset}
                                                                editEvent={editEvent}
                                                                event={data?.maintenance_events}
                                                                onDeleteAssembly={() => setDeleteAssemblys({ modal: true, data: { assembly_slug: data?.slug, id: data?.id } })}
                                                                onEditAssemblys={() => setAddAssemblys({ modal: true, data: { ...data, asset: data?.asset, assembly_slug: data?.slug, event_slug: data.slug }, mode: 'edit' })}
                                                                onViewAssemblys={() => setAddAssemblys({ modal: true, mode: "view", data: { ...data, asset: data?.asset, assembly_slug: data?.slug } })}
                                                                setEditEvent={setEditEvent}
                                                                onDelete={(event) => setDeleteEvents({ modal: true, data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event.slug } })}
                                                                onEdit={(event) => setEditEvent({ modal: true, data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event.slug, maintenance_types: data?.maintenance_events?.map(m => m?.maintenance_type) }, mode: 'edit' })}
                                                                onAdd={() => setEditEvent({ modal: true, data: { asset: data?.asset, assembly_slug: data?.slug || "", event_slug: Array.isArray(data?.maintenance_events) && data?.maintenance_events[0]?.slug ? data.maintenance_events[0].slug : "", maintenance_types: data?.maintenance_events?.map(m => m?.maintenance_type) }, mode: 'add' })}
                                                                addAssemblys={addAssemblys}
                                                                permissionKey='return_conditions'
                                                                pageTitle='Return Condition'
                                                                item={data}
                                                                onView={(event) => setEditEvent({ modal: true, mode: 'view', data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event?.slug, maintenance_types: data?.maintenance_events?.map(m => m?.maintenance_type) } })}
                                                                viewFile={(item) => setUploadfile({ modal: true, mode: "file", data: item || data })}
                                                                uploadedFileData={uploadFileProgressData}
                                                                slug={slug?.slug}
                                                                viewFileStatus={() => setUploadFileStatus({ modal: true, data: uploadFileProgressData, mode: 'view' })}
                                                            />
                                                        );
                                                    }) : (<Box sx={{ textAlign: 'center', height: "40px" }}><Box mt={1}>{"No Assemblies found for this lease"}</Box></Box>)
                                            }
                                        </Box>
                                    },
                                    {
                                        label: 'Actual Config',
                                        content: <Box className="redelivery-assemblies-table" sx={{ backgroundColor: "#FAFAFA", padding: "10px", ...contentScrollSx }}>
                                            <Box display="flex" justifyContent="space-between" marginBottom={1}>
                                                <Typography color='primary' className='delivery-header'>Return Assemblies</Typography>
                                            </Box>
                                            {
                                                isDropDownLoading.actualConfigDetails ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} variant="rectangular" height={40} />) :
                                                    assemblysType.length > 0 ? addAssemblysActualConfigType?.map((data, index) => {
                                                        return (
                                                            <AssemblyTable
                                                                tabValue={tabValue}
                                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: data, mode: 'view' })}
                                                                key={index}
                                                                tsn={data?.tsn}
                                                                csn={data?.csn}
                                                                blockHours={data?.block_hours}
                                                                asset={data?.asset}
                                                                editEvent={editEvent}
                                                                event={data?.maintenance_events}
                                                                setEditEvent={setEditEvent}
                                                                onDelete={(event) => setDeleteEvents({ modal: true, data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event.slug } })}
                                                                onEdit={(event) => setEditEvent({ modal: true, data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event.slug }, mode: 'edit' })}
                                                                onAdd={() => setEditEvent({ modal: true, data: { asset: data?.asset, assembly_slug: data?.slug || "", event_slug: Array.isArray(data?.maintenance_events) && data?.maintenance_events[0]?.slug ? data.maintenance_events[0].slug : "" }, mode: 'add' })}
                                                                addAssemblys={addAssemblys}
                                                                permissionKey='return_conditions'
                                                                pageTitle='Return Condition'
                                                                item={data}
                                                                onView={(event) => setEditEvent({ modal: true, mode: 'view', data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event?.slug, maintenance_types: data?.maintenance_events?.map(m => m?.maintenance_type) } })}
                                                                viewFile={(item) => setUploadfile({ modal: true, mode: "file", data: item || data })}
                                                                uploadFileProgressData={uploadFileProgressData} viewFileStatus={() => setUploadFileStatus({ modal: true, data: uploadFileProgressData, mode: 'view' })}
                                                            />
                                                        );
                                                    }) : (<Box sx={{ textAlign: 'center', height: "40px" }}><Box mt={1}>{"No Assemblies found for this lease"}</Box></Box>)
                                            }
                                        </Box>
                                    },
                                    {
                                        label: 'Return Information',
                                        content: (
                                            <Paper elevation={0} container spacing={2} mt={3} mr={2} sx={{ padding: '3px 0px 7px 7px', margin: '10px 1px 2px 1px', borderRadius: 2, boxShadow: '0px 0px 0px 1px #BBBBBB', ...contentScrollSx }}>
                                                <Grid sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
                                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "return_conditions", operationType: ['U'] }}>
                                                        <Tooltip title="Edit"><EditIcon sx={{marginRight: '0px'}} fontSize="small" color="primary" className='delivery-edit-btn' onClick={() => { setEditRedelivery({ modal: true, data: data, mode: 'add' }); handleItemClicked('EditIcon') }} /></Tooltip>
                                                    </PermissionWrapper>
                                                </Grid>
                                                <Grid className="redelivery-contractual-container" container spacing={2} mt={2}>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.contractual_redelivery_date ? moment(data?.contractual_redelivery_date).format("DD-MM-YYYY") : ""}
                                                                label="Return Date Contractual"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.actual_redelivery_date ? moment(data?.actual_redelivery_date).format("DD-MM-YYYY") : ""}
                                                                label="Return Date Actual"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}

                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.estimated_redelivery_date ? moment(data?.estimated_redelivery_date).format("DD-MM-YYYY") : ""}
                                                                label="Return Date Estimated"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}

                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.redelivery_location}
                                                                label="Return Location"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}

                                                    </Grid>
                                                    {editmode ?
                                                        <Grid size={{ md: 12, xs: 12 }}>
                                                            {isDropDownLoading.data ? (
                                                                <Skeleton variant="rectangular" height={80} />
                                                            ) : (
                                                                <TextField
                                                                    value={data?.redelivery_remarks}
                                                                    label="Remarks"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    margin="normal"
                                                                    disabled={true}
                                                                    slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                    fullWidth rows={getTextFieldRows(data?.redelivery_remarks, 3, 115)}
                                                                    multiline
                                                                    sx={{ '& .MuiInputBase-root': { backgroundColor: '#f3f3f3' } }} />
                                                            )}
                                                        </Grid> : <Grid item size={{ md: 12, xs: 12 }}>
                                                            <LessMoreTextFieldComp label='Remarks' value={data?.redelivery_remarks || ""} rows={getTextFieldRows(data?.redelivery_remarks, 3, 164)} />
                                                        </Grid>}
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <FormGroup className='disabled-checkbox-wrapper'>
                                                            <Box className="check-item-div" sx={{cursor: !editmode ? "not-allowed" : "pointer"}}>
                                                                <Checkbox checked={data?.redelivery_serviceable === true ? true : false} disabled />
                                                                <Typography className="check-item-span" fontSize='14px'>Serviceable</Typography>
                                                            </Box>
                                                        </FormGroup>
                                                    </Grid>

                                                    <Typography color="primary" sx={{ width: "100%" }} className="delivery-assembly">Contractual Details</Typography>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (<TextField
                                                            value={data?.contractual_operating_region}
                                                            label="Fit Operational Region"
                                                            variant="outlined"
                                                            size="small"
                                                            margin="normal"
                                                            disabled={true}
                                                            slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                            fullWidth
                                                        />)}
                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.contractual_livery}
                                                                label="Livery"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.contractual_lease_expiry_c_check}
                                                                label="Lease Expiry C-Check"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}

                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                readOnly={true}
                                                                value={data?.contractual_return_original_engine}
                                                                label="Return with Original Engine"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.contractual_location}
                                                                label="Location"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}

                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.contractual_country}
                                                                label="Country"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}

                                                    </Grid>
                                                    <Grid size={{ md: 3, xs: 12 }}>
                                                        {isDropDownLoading.data ? (
                                                            <Skeleton variant="rectangular" height={40} />
                                                        ) : (
                                                            <TextField
                                                                value={data?.premature_redelivery}
                                                                label="Premature Redelivery"
                                                                variant="outlined"
                                                                size="small"
                                                                margin="normal"
                                                                disabled={true}
                                                                slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                fullWidth
                                                            />
                                                        )}
                                                    </Grid>
                                                    {editmode ?
                                                        <Grid size={{ md: 12, xs: 12 }}>
                                                            {isDropDownLoading.data ? (
                                                                <Skeleton variant="rectangular" height={80} />
                                                            ) : (
                                                                <TextField
                                                                    value={data?.contractual_comments}
                                                                    label="Comments"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    margin="normal"
                                                                    disabled={true}
                                                                    slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                    fullWidth rows={getTextFieldRows(data?.contractual_comments, 3, 110)}
                                                                    multiline
                                                                    sx={{ '& .MuiInputBase-root': { backgroundColor: '#f3f3f3' } }}
                                                                />
                                                            )}
                                                        </Grid> : <Grid item size={{ md: 12, xs: 12 }}>
                                                        <LessMoreTextFieldComp label='Comments' value={data?.contractual_comments || ""} rows={getTextFieldRows(data?.contractual_comments, 3, 164)} />
                                                    </Grid>}

                                                </Grid>
                                            </Paper>
                                        )
                                    }
                                ]} />
                            </Box>
                        </Grid>
                    </Box>
                </div>
                {
                    editRedelivery.modal ?
                        <EditRedelivery
                            editRedelivery={editRedelivery}
                            getResponseBack={() => getDeliveryConditionDetail('fetch')}
                            onToggleModal={() => setEditRedelivery({ modal: false, data: null, mode: '' })}
                        /> : null
                }

                {
                    addAssemblys.modal && (
                        <AddAssemblys
                            assemblysType={assemblysType}
                            addAssemblys={addAssemblys}
                            setAddAssemblys={setAddAssemblys}
                            modeType={addAssemblys?.mode}
                            getResponseBack={() => getAssemblysTypeList('fetch')}
                            onToggleModal={() => setAddAssemblys({ modal: false, data: null, mode: '' })}
                        />
                    )
                }

                {
                    editEvent.modal && (
                        <EditAssemblysEvent
                            tabValue={tabValue === 1}
                            params={{ params, asset: editEvent?.data?.asset, assembly_slug: editEvent?.data?.assembly_slug, event_slug: editEvent?.data?.event_slug }}
                            editEvent={editEvent}
                            onToggleModal={() => setEditEvent({ modal: false, data: null, mode: '' })}
                            getResponseBack={() => tabValue === 0 ? getAssemblysTypeList('fetch') : getAssemblysTypeActualConfigList('fetch')}
                            modeType={editEvent?.mode}
                            openAttachment={() => setUploadfile({ modal: true, data: editEvent?.data, mode:'view' })}
                            fileUpload={handleUpload}
                        />
                    )
                }
                {deleteAssemblys.modal &&
                    <DeletePopUp
                        modal={deleteAssemblys.modal}
                        title='Delete Assembly'
                        content={`Are you sure, you want to Delete?`}
                        onToggleModal={() => setDeleteAssemblys({ modal: false, data: null })}
                        onDeleteRecords={() => onDeleteAssembly()}
                    />}
                {deleteEvents.modal &&
                    <DeletePopUp
                        modal={deleteEvents.modal}
                        title='Delete Event'
                        content={`Are you sure, you want to Delete?`}
                        onToggleModal={() => setDeleteEvents({ modal: false, data: null })}
                        onDeleteRecords={() => onDeleteAssemblyEvent()}
                    />}
                {
                    revisionHistory.modal &&
                    <RevisionHistory
                        section_type={"re-delivery"}
                        moduleName={revisionHistory?.tableName === "event" ? "delivery_redelivery_maintenance_event" : "delivery_redelivery_assembly"}
                        revisionHistory={revisionHistory}
                        onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                    />
                }

                {uploadfile?.modal &&
                    <ShowAttachments
                        url='delete-attachment'
                        moduleName="Return Condition"
                        attachmentsData={uploadfile}
                        getResponseBack={onDeletAttachments}
                        toggleModalFn={() => setUploadfile({ modal: false, mode: '', data: null })}
                        onViewDisabled={uploadfile?.mode === 'view'}
                        permissionKey="return_conditions"
                    />
                }
                <FileUploadLayout
                    uploadFileStatus={uploadFileStatus}
                    open={uploadFileStatus?.modal}
                    setUploadFileStatus={setUploadFileStatus}
                    uploadFileProgressData={uploadFileProgressData}
                    progressRefs={uploadFileProgressData?.progressRefs}
                    attachments={uploadFileProgressData?.attachments}
                    onDownloadComplete={() => setSlug({})}
                />
                {isLoading ? <PageLoader /> : null}
            </Paper>
        </>
    )
}
export default RoleBaseAccess(Redelivery, { application: 'lease_revamp', feature: 'return_conditions', operationType: ['R'], leaseNav: true });
